// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useRef } from 'react';

/**
 * Returns the previously returned value while the caller's equality check
 * says nothing changed, so derived arrays and objects keep a stable
 * identity across renders and memoized consumers skip re-rendering.
 */
export function useStableValue<T>(
  value: T,
  isEqual: (previous: T, next: T) => boolean
): T {
  const previousRef = useRef(value);
  if (previousRef.current !== value && !isEqual(previousRef.current, value)) {
    previousRef.current = value;
  }
  return previousRef.current;
}
